import styled from "styled-components";

export const P = styled.p`
    font-family: ${props => props.theme.lightFont};
    font-size: 16px;
    font-weight: 300;
    line-height: 21.6px;
    color: ${props => props.theme.textColor};
    margin: ${props => props.margin};
`;

export const PDescribe = styled.p`
    font-family: ${props => props.theme.lightFont};
    font-size: 18px;
    font-weight: 300;
    line-height: 30px;
    text-align: center;
    color: ${props => props.theme.textColor};
    margin: 0;
`;

export const PDescribe2 = styled.p`
    font-family: ${props => props.theme.lightFont};
    font-size: 20px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;
    text-align: left;
    color: ${props => props.theme.textColor};
    margin: ${props => props.$margin};
`;

export const PQuote = styled.q`
    font-family: ${props => props.theme.normalFont};
    font-size: 20px;
    font-weight: 300;
    line-height: 27px;
    text-align: center;
    color: ${props => props.theme.textColor};
`;

export const OfferText = styled.p`
    font-family: ${props => props.theme.normalFont};
    color: ${props => props.theme.textColor};
    font-size: 48px;
    font-weight: 600;
    line-height: 48.22px;
    text-align: center;
`;

export const OfferSpan = styled.span`
    font-family: ${props => props.theme.normalFont};
    color: ${props => props.theme.textColor};
    font-size: 48px;
    line-height: 48.22px;
    text-align: center; 
    font-weight: 300;
`;